// From
// https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript

const errorFunction = (error: Error) => console.warn('Copy to clipboard failed.', error);
export function copyToClipboard(text: string, onFail = errorFunction): boolean {
  const castedWindow = window as any;

  // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
  if (castedWindow.clipboardData && castedWindow.setData) {
    return castedWindow.clipboardData.setData('Text', text);
  } else if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
    console.log('executing command');
    var temporaryTextArea = document.createElement('textarea');
    temporaryTextArea.textContent = text;
    temporaryTextArea.value = text;
    temporaryTextArea.style.position = 'fixed'; // Prevent scrolling to bottom of page in Microsoft Edge.

    document.body.appendChild(temporaryTextArea);
    temporaryTextArea.select();
    temporaryTextArea.focus();

    let result = false;
    try {
      result = document.execCommand('copy'); // Security exception may be thrown by some browsers.
      document.body.removeChild(temporaryTextArea);
    } catch (ex) {
      onFail(ex);
      result = false;
    } finally {
      return result;
    }
    // Failing
  } else if (!!navigator?.clipboard) {
    navigator.clipboard.writeText(text);
  } else {
    onFail(new Error('No copying supported'));
    return false;
  }
}
